import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__tabs-with-checkboxes';
const CHECKBOX_SELECTOR = '.js__tabs-with-checkboxes-tab-checkbox';
const TAB_SELECTOR = '.js__tabs-with-checkboxes-tab';
const INDICATOR_SELECTOR = '.js__tabs-with-checkboxes-indicator';
const BUTTON_SELECTOR = '.js__tabs-with-checkboxes-button';
export class TabsWithCheckbox {
    static init($root = $('body')) {
        const $tabsWithCheckboxes = $root.find(ELEMENT_SELECTOR);
        if (!$tabsWithCheckboxes.length) {
            return;
        }
        $tabsWithCheckboxes.each((index, element) => {
            $tabsWithCheckboxes.find(CHECKBOX_SELECTOR).on('change', e => {
                const $checkbox = $(e.currentTarget);
                const $tab = $checkbox.closest(TAB_SELECTOR);
                const isAnyChecked = $tab.find(`${CHECKBOX_SELECTOR}:checked`).length;
                const $tabButton = $checkbox
                    .closest(ELEMENT_SELECTOR)
                    .find(`${BUTTON_SELECTOR}[data-tab="${$tab.data('tab')}"]`);
                const $indicator = $tabButton.find(INDICATOR_SELECTOR);
                $indicator.toggleClass('hidden', !isAnyChecked);
            });
        });
    }
}
